import { colors } from '@lmc/common/constants'
import { Button, Icon } from '@lmc/ui-kit'
import { type ChangeEvent, useState } from 'react'
import styled from 'styled-components'
import { FormInput } from '../../../generic'

export interface FormProps {
  color: string
  iconText: string
  name: string
}

interface AssessmentEditableHeaderProps {
  form: FormProps
  hasToggle?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string
}

export default function AssessmentEditableHeader({
  form,
  hasToggle,
  onChange,
  value
}: AssessmentEditableHeaderProps) {
  const [hasClickedToggle, setHasClickedToggle] = useState(false)

  if (!form || !onChange) return null

  const { color, iconText, name } = form
  const isShowingToggle = hasToggle && !hasClickedToggle

  return (
    <Wrapper>
      <IconContainer style={{ background: color }}>
        <IconText>{iconText}</IconText>
      </IconContainer>
      <TitleContainer style={{ paddingLeft: iconText ? 15 : 0 }}>
        <TextContainer>
          <Title>{name} for</Title>
          {isShowingToggle ? (
            <ToggleContainer>
              <Title>{value}</Title>
              <StyledButton onClick={() => setHasClickedToggle(true)}>
                <Icon name="EditOutlined" />
              </StyledButton>
            </ToggleContainer>
          ) : (
            <FormInput
              // @ts-ignore
              autoFocus
              className="lmc-sub-card-edit"
              onChange={onChange}
              style={{
                color: colors.black,
                flex: 1,
                fontSize: 24,
                marginLeft: 5,
                paddingBottom: 2
              }}
              value={value}
            />
          )}
        </TextContainer>
      </TitleContainer>
    </Wrapper>
  )
}

const IconContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  display: flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  width: 40px;
`

const IconText = styled.span`
  color: white;
  font-size: 12px;
  font-weight: bold;
`

const StyledButton = styled(Button)`
  background: transparent !important;
  color: ${colors.black} !important;
  height: 30px;
  margin-left: 6px;
  position: relative;
  top: -1px;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.orange} !important;
    color: white !important;
  }
`

const TextContainer = styled.div`
  align-items: center;
  display: flex;
`

const Title = styled.span`
  font-size: 24px;
  min-height: 37px;
`

const TitleContainer = styled.div`
  flex: 1;
`

const ToggleContainer = styled.div`
  display: flex;
  padding-left: 8px;
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`
